import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function useConnstantBussinesName(data) {
  const { id } = useSelector((state) => state.editModal);
  const [editValues, setEditValues] = useState({});

  useEffect(() => {
    if (id && data.length) {
      const filtered = data.filter((businessName) => businessName.id === id);
      setEditValues(filtered[0]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, data.length, data]);

  const fields = [
    {
      id: "descripcion",
      label: "Nombre de Razon Social",
      type: "text",
      value: editValues?.descripcion || "",
      required: true,
    },
  ];

  const element = {
    button: "Agregar Razon Social",
  };

  return [fields, element];
}
